/**
 * Indicador visual del ambiente actual — chip inline para la barra superior
 * del MainLayout (antes era un overlay fijo abajo-derecha que tapaba botones).
 * Solo visible en development y staging, nunca en producción.
 */
import { esProduccion } from '../../config/entorno';

export function EnvironmentBadge() {
  const useEmulators = import.meta.env.VITE_USE_EMULATORS === 'true';

  if (esProduccion) return null;

  const label = useEmulators ? 'LOCAL' : 'DEV';
  // Incluye la marca de build: pasar el mouse sobre el chip DEV muestra qué
  // versión del portal está cargada — clave para detectar bundles en caché.
  const detalle = useEmulators
    ? `Firebase Emulators locales · build ${__BUILD_TS__}`
    : `Proyecto Firebase: ${import.meta.env.VITE_FIREBASE_PROJECT_ID} · build ${__BUILD_TS__}`;
  const color = useEmulators ? '#B07700' : '#1F6FB8';
  const bg = useEmulators ? 'var(--color-warning-bg)' : 'var(--color-info-bg)';

  return (
    <span
      title={detalle}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        background: bg,
        color,
        padding: '2px 8px',
        borderRadius: 'var(--radius-full)',
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: '0.04em',
        whiteSpace: 'nowrap',
        flexShrink: 0,
        cursor: 'default',
      }}
    >
      <span
        aria-hidden="true"
        style={{
          width: 6,
          height: 6,
          borderRadius: '50%',
          background: color,
        }}
      />
      {label}
    </span>
  );
}
